import { createContext, useContext } from 'react';
import type { PageData } from '@/types';
import { getEmbeddedJson } from '@/utils/getEmbeddedJson';
import { JsonScriptId } from '@/constants';
import type { ProviderProps } from './types';

const PageContext = createContext<PageData | null>(null);

export const PageDataProvider = ({ children }: ProviderProps) => {
  const pageData: PageData = getEmbeddedJson(JsonScriptId.Page);
  return (
    <PageContext.Provider value={pageData}>{children}</PageContext.Provider>
  );
};

export const usePageData = () => {
  const context = useContext(PageContext);

  if (context === undefined || context === null) {
    throw new Error('usePageData must be used within a PageContext Provider');
  }

  return context;
};
